module.exports = __webpack_public_path__ + "img/animated-technology.f0336e58.svg";